module.exports = __webpack_public_path__ + "img/bell.97effec.svg";